<template>
    <div class="mobile-nav-main">
        <div class="mobile-menu-city" v-if="currentCityArr != null">
            <li class="parent-link" data-href="/city-select" key="city" :class="{open : currentIndex == 'city'}">
                <a href="#" @click.prevent="setCurrentIndex('city', '/city-select')">
                    <span>{{currentCityArr[0].region}}</span>
                    <div class="nav-icon"></div>
                </a>
                <slide-up-down :active="currentIndex == 'city'" :duration="400" class="dropdown-menu">
                    <ul>
                        <li v-for="(item, index) in setup.regions_name" v-if="item.city_init == 'true'">
                            <a href="#" @click.prevent="setCurrentCity(item.region_lat.slug)">{{item.region}}</a>
                        </li>
                    </ul>
                </slide-up-down>
            </li>
        </div>

        <div class="mobile-menu-phone" v-if="currentCityArr != null">
            <a :href="'tel:' + currentCityArr[0].region_phone" class="phone-number">{{currentCityArr[0].region_phone}}</a>
        </div>

        <ul class="list-unstyled nav">
            <li class="parent-link" data-href="bazis_link">
               <a href="https://bazis.kz" target="_blank">Bazis-A</a>
            </li>
            <li v-for="(item, index) in setup.main_page_navigation" class="parent-link" :data-href="item.href" :key="index" :class="{open : currentIndex == index}">
                <a href="#" @click.prevent="setCurrentIndex(index, item.href)">
                    <span>{{item.name}}</span>
                    <div class="nav-icon" v-if="item.dropdown != false"></div>
                </a>
                <slide-up-down :active="currentIndex == index" :duration="400" v-if="item.dropdown != false" class="dropdown-menu">
                    <ul>
                        <li v-for="link in item.dropdown">
                            <router-link :to="link.href" @click.native="startLoader">{{link.name}}</router-link>
                        </li>
                    </ul>
                </slide-up-down>
            </li>
        </ul>
    </div>
</template>

<script>
    import SlideUpDown from 'vue-slide-up-down'
    import {mapGetters} from 'vuex'
    export default {
        name: 'mobile-nav-main',
        data () {
            return {
                currentIndex: 0,
                regionCity: null,
            }
        },
        components: {
            SlideUpDown,
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            currentCityArr: 'loadCurrentCityArr',
        }),
        methods: {
            setCurrentIndex(index, link) {
                console.log(link)
                if (link == '/news') {
                    this.$router.push('/news');
                    this.$parent.$parent.$refs.topProgress.start();
                } else if (link == '/bazis-club') {
                    this.$router.push('/bazis-club');
                    this.$parent.$parent.$refs.topProgress.start();
                } else if (link == '/video') {
                    this.$router.push('/video');
                    this.$parent.$parent.$refs.topProgress.start();
                } else if (link == '/contacts') {
                    this.$router.push('/contacts');
                    this.$parent.$parent.$refs.topProgress.start();
                }
                if (this.currentIndex == index) {
                    this.currentIndex = null;
                } else {
                    this.currentIndex = index
                }
                // console.log(index)
            },
            setCurrentCity(city) {
                this.$store.commit('CurrentCity', city);
                localStorage.setItem('regionCity', city);
                this.filterRegion(city);
                this.regionCity = city;
                document.location.reload(true);
            },
            filterRegion(city) {
                var data = this.setup.regions_name;
                var filteredItems = data.filter(item => {
                    return item.region_lat.slug === city
                })
                this.$store.commit('CurrentCityArr', filteredItems);
            },
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/respond/nav-main/respond-nav-main.scss';
</style>